define('core/CappedStorage',[
    'core/utils/storage',
], function (
    storage
) {
    'use strict';

    /**
     * Like local storage but caps the number of items you can put into it.
     * Once you hit the cap, the first item that was stored is removed
     * in order to make room for the new item.
     *
     * @param {number} max      the maximum number of items in the store
     * @param {string} queueKey key to be used by the underlying storage for this object
     */
    var CappedStorage = function (max, queueKey) {
        this.max = max || 10;
        this.queueKey = queueKey || '__queue';

        if (!this.getQueue())
            this.setQueue([]);
    };

    CappedStorage.prototype.set = function (key, value) {
        var queue = this.getQueue() || this.setQueue([]);

        if (queue.length === this.max)
            storage.remove(queue.shift());

        storage.set(key, value);

        queue.push(key);
        this.setQueue(queue);
    };

    CappedStorage.prototype.get = function (key) {
        return storage.get(key);
    };

    CappedStorage.prototype.remove = function (key) {
        storage.remove(key);
        var queue = this.getQueue() || [];

        for (var i = 0; i < queue.length; i++) {
            if (queue[i] === key) {
                queue.splice(i, 1);
                break;
            }
        }
        this.setQueue(queue);
    };

    CappedStorage.prototype.clear = function () {
        storage.clear();
        this.setQueue([]);
    };

    CappedStorage.prototype.getQueue = function () {
        return storage.get(this.queueKey);
    };

    CappedStorage.prototype.setQueue = function (queue) {
        storage.set(this.queueKey, queue);
        return queue;
    };

    return CappedStorage;
});

